import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import User from 'models/core/user/Model.User';
import Dealer from 'models/dealerManagement/dealer/Model.Dealer';
import Model from 'models/Model';
import Statement from 'models/sales/statement/Model.Statement';
import AccountReceivableComment from '../accountReceivableComment/Model.AccountReceivableComment';
import accountReceivableDeleteApi from './delete/Api.AccountReceivable.Delete';
import accountReceivableDeleteChequeDocumentApi from './deleteChequeDocument/Api.AccountReceivable.DeleteChequeDocument';
import accountReceivableFindApi from './find/Api.AccountReceivable.Find';
import accountReceivableImportFromExcelApi from './importFromExcel/Api.AccountReceivable.ImportFromExcel';
import accountReceivableListApi from './list/Api.AccountReceivable.List';
import accountReceivableSaveApi from './save/Api.AccountReceivable.Save';
import accountReceivableUploadChequeDocumentApi from './uploadChequeDocument/Api.AccountReceivable.UploadChequeDocument';

export default class AccountReceivable
  extends Model<Model.IAccountReceivable>({ icon: 'if-login' })
  implements Model.Instance<Model.IAccountReceivable>
{
  id: number;

  dealerDisplayName: string;

  dealerId?: number;
  dealer?: Dealer;

  statementId?: number;
  statement?: Statement;

  possibleDuplicate: boolean;

  amount: number;

  contactName: string;
  contactEmail: string;

  statusCode: string;
  paymentMethodCode: string;

  createdAtLocal: string;
  createdAtUtc: string;
  modifiedAtUtc: string;
  paymentReceivedAtUtc?: string;

  externalPaymentReference: string;
  internalPaymentReference: string;

  chequeNumber: string;
  chequeDateAtUtc?: string;
  chequeDocumentId?: number;
  chequeDocument?: MediaFile;

  evidenceSource: string;
  evidenceDocumentId?: number;
  evidenceDocument?: MediaFile;

  createdById?: number;
  createdBy?: User;

  modifiedById?: number;
  modifiedBy?: User;

  accountReceivableComments?: AccountReceivableComment[];

  constructor(
    data: Partial<Model.IAccountReceivable> | Utils.FormData<Model.IAccountReceivable>,
    language?: Locale.Languages
  ) {
    super(
      {
        dealer: Dealer,
        statement: Statement,
        chequeDocument: MediaFile,
        evidenceDocument: MediaFile,
        createdBy: User,
        modifiedBy: User,
        accountReceivableComments: [AccountReceivableComment],
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.dealerDisplayName || this.dealer?.name,
      subtitle: this.statement?.statementNumber?.toString() || this.statement?.id?.toString(),
    };
  }
  static async list(body?: Api.Finance.AccountReceivable.List.IRequest) {
    const { payload, ...rest } = await accountReceivableListApi(body);
    return {
      ...rest,
      payload: payload && {
        data: payload.data?.map((it) => new AccountReceivable(it)),
        count: payload.count,
      },
    };
  }
  static async find(params: { id: number }) {
    const { payload, ...rest } = await accountReceivableFindApi(params);
    return {
      ...rest,
      payload: new AccountReceivable(payload),
    };
  }
  static async importFromExcel(body: Api.Finance.AccountReceivable.ImportFromExcel.IRequest) {
    return await accountReceivableImportFromExcelApi(body);
  }
  async save() {
    return await accountReceivableSaveApi(this);
  }
  async delete() {
    return await accountReceivableDeleteApi(this.id);
  }
  async uploadChequeDocument(body: Api.Finance.AccountReceivable.UploadChequeDocument.IRequest) {
    return await accountReceivableUploadChequeDocumentApi(this.id, body);
  }
  async deleteChequeDocument(fileId: number) {
    return await accountReceivableDeleteChequeDocumentApi(this.id, fileId);
  }
}
